import { Match, Switch } from 'solid-js'
import { getMetricDefinition } from '@fasting-timer/shared'

import MetricPicker from '../components/measurements/MetricPicker'
import MetricView from '../components/measurements/MetricView'
import SleepView from '../components/sleep/SleepView'
import { viewPanelState } from '../state/appUiStore'
import { selectedMetricId } from '../state/measurementsUiStore'
import WeightView from './WeightView'

/**
 * Renders the measurements tab: a metric picker and the view for the selected
 * metric (weight and sleep have their own views).
 *
 * @returns The measurements view element.
 */
const MeasurementsView = () => (
   <div
      id="measurements-view"
      class="view-panel w-full space-y-4 lg:col-span-2"
      data-view-state={viewPanelState('measurements')}
   >
      <MetricPicker />
      <Switch>
         <Match when={selectedMetricId() === 'weight'}>
            <WeightView />
         </Match>
         <Match when={selectedMetricId() === 'sleep'}>
            <SleepView />
         </Match>
         <Match when={getMetricDefinition(selectedMetricId())}>
            {definition => <MetricView definition={definition()} />}
         </Match>
      </Switch>
   </div>
)

export default MeasurementsView
